import numeral from "numeral";

export const EMPTY_MONEY_CONFIG = {
    cash: 0,
    daviplata: 0,
    nequi: 0,
    terminal: 0,
    terminal1: 0,
    terminal2: 0,
    terminal3: 0,
    bre_b: 0,
    online: 0
};

const getMoneyConfigFromTypeAndValueNequi = (value) => ({
    ...EMPTY_MONEY_CONFIG,
    nequi: value
});

const getMoneyConfigFromTypeAndValueDaviplata = (value) => ({
    ...EMPTY_MONEY_CONFIG,
    daviplata: value
});

const getMoneyConfigFromTypeAndValueCash = (value) => ({
    ...EMPTY_MONEY_CONFIG,
    cash: value
});

const getMoneyConfigFromTypeAndValueTerminal = (value) => ({
    ...EMPTY_MONEY_CONFIG,
    terminal: value
});

const getMoneyConfigFromTypeAndValueTerminal1 = (value) => ({
    ...EMPTY_MONEY_CONFIG,
    terminal1: value
});

const getMoneyConfigFromTypeAndValueTerminal2 = (value) => ({
    ...EMPTY_MONEY_CONFIG,
    terminal2: value
});

const getMoneyConfigFromTypeAndValueTerminal3 = (value) => ({
    ...EMPTY_MONEY_CONFIG,
    terminal3: value
});

export const getMoneyConfigFromPaymentMethodAndValue = (
    paymentMethod,
    value
) => {
    const moneyConfigs = {
        cash: getMoneyConfigFromTypeAndValueCash,
        daviplata: getMoneyConfigFromTypeAndValueDaviplata,
        nequi: getMoneyConfigFromTypeAndValueNequi,
        terminal: getMoneyConfigFromTypeAndValueTerminal,
        terminal1: getMoneyConfigFromTypeAndValueTerminal1,
        terminal2: getMoneyConfigFromTypeAndValueTerminal2,
        terminal3: getMoneyConfigFromTypeAndValueTerminal3
    };
    const handler =
        moneyConfigs[paymentMethod] || getMoneyConfigFromTypeAndValueCash;
    return handler(value);
};

export const sumMoneyConfig = (ag1, ag2) => {
    return {
        cash: ag1.cash + ag2.cash,
        daviplata: ag1.daviplata + ag2.daviplata,
        nequi: ag1.nequi + ag2.nequi,
        terminal: ag1.terminal + ag2.terminal,
        terminal1: ag1.terminal1 + ag2.terminal1,
        terminal2: ag1.terminal2 + ag2.terminal2,
        terminal3: ag1.terminal3 + ag2.terminal3,
        online: ag1.online + ag2.online
    };
};

export const calculateOrdersPaymentDistribution = (orders = []) => {
    const result = orders.reduce(
        (acc, order) => {
            const money = getMoneyConfigFromPaymentMethodAndValue(
                order.paymentMethod,
                order.total
            );
            const count = sumMoneyConfig(acc, money);
            return { ...count, total: acc.total + order.total };
        },
        { ...EMPTY_MONEY_CONFIG, total: 0 }
    );
    return result;
};

export const sanitizeMoneyInput = (raw) => {
    let str = String(raw ?? "").replace(/\s/g, "");
    str = str.replace(/[^0-9.kKmM]/g, "");
    const dotIdx = str.indexOf(".");
    if (dotIdx !== -1) {
        str =
            str.slice(0, dotIdx + 1) + str.slice(dotIdx + 1).replace(/\./g, "");
    }
    const suffixIdx = str.search(/[kKmM]/);
    if (suffixIdx !== -1) {
        str = str.slice(0, suffixIdx + 1);
    }
    return str;
};

export const parseMoneyShorthand = (input) => {
    if (input === null || input === undefined) return 0;
    const str = String(input).trim().replace(/\s/g, "");
    if (!str || str === "-") return 0;
    const match = str.match(/^(\d*\.?\d*)([kKmM]?)$/);
    if (!match) return 0;
    const numStr = match[1];
    const suffix = match[2].toLowerCase();
    if (!numStr) return 0;
    const num = parseFloat(numStr);
    if (isNaN(num)) return 0;
    if (suffix === "k") return Math.round(num * 1000);
    if (suffix === "m") return Math.round(num * 1000000);
    return Math.round(num);
};

export const formatMoney = (value) => {
    if (value === undefined || value === null) {
        return "$ -";
    }
    if (!value) {
        return "$ 0";
    }
    return numeral(value).format("$ 0[.]000 a");
};

export const formatCurrency = (value, abbreviation = true, join = false) => {
    if (value === undefined || value === null) {
        return "$ -";
    }
    if (!value) {
        return "$ 0";
    }
    const space = join ? "" : " ";
    return numeral(value).format(
        abbreviation ? `$${space}0,0` : `$${space}0,0.00'`
    );
};
